export const isDev = process.env.NODE_ENV === 'development'

// const baseUrl = isDev ? '/' : window.baseUrl
const baseUrl = window.baseUrl

export const uploadUrl = isDev ? window.uploadUrl : window.uploadUrl

// 商城
//上传Excel
export const uploadExcle = baseUrl + 'order/uploadExcle'
//获取Excel内容
export const getExcelMessage = baseUrl + 'order/getExcelMessage'
// 上传物流号
export const uploadOrder = baseUrl + 'order/uploadOrder'

// 获取订单列表
export const getOrderList = baseUrl + 'order/getAllOrders'
// 获取订单详情
export const getOrderDetail = baseUrl + 'order/getOrderDetail'

// 导出
export const getWaitPackGood = baseUrl + 'order/getWaitPackGood'
// 再次导出
export const getRepeatPack = baseUrl + 'order/getExportByTid'
// 获取任务列表
export const getTaskList = baseUrl + 'order/getTaskList'

// =================================== api ==================================
// 登录
export const login = baseUrl + 'home/AjaxLogin'
// 退出
export const loginout = baseUrl + 'home/Newloginout'
// 控制台
export const homeCenter = baseUrl + 'home/NewAjaxCenter'
// 订单管理
export const orderList = baseUrl + 'order/getAllOrders'
// 优惠券管理
export const couponList = baseUrl + 'order/couponList'
// 订单详情
export const orderEdit = baseUrl + 'Order/NewEdit?fromSys='
// 轮询查询订单接口
export const orderNext = baseUrl + 'order/getNewOrder'
// 操作日志
export const OrderOperate = baseUrl + 'order/NewAjaxOrderOperate'
// 订单从待支付转为已支付
export const payAccept = baseUrl + 'order/NewAjaxPayAccept'
// 订单从待支付转为订单无效
export const payReject = baseUrl + 'order/NewAjaxPayReject'
// 订单管理页面打印订单
export const printOrder = baseUrl + 'Order/PrintOrderAgain?merTxNo='
// 获取店铺信息
export const GetShopId = baseUrl + 'Menu/AjaxGetShop'
// 菜品管理
export const MenuList = baseUrl + 'Menu/NewAjaxMenuList?fromSys='
// 获取添加菜品数据
export const getAddFood = baseUrl + 'Menu/NewAddFood2'
// 添加菜品
export const addFood = baseUrl + 'Menu/NewAjaxAddFood'
// 获取菜单编辑页面数据
export const getEditFood = baseUrl + 'Menu/NewFoodEdit'
// 提交菜品编辑
export const EditFood = baseUrl + 'Menu/NewAjaxEditFood'
// 类别管理
export const CategoryList = baseUrl + 'Menu/NewAjaxCategoryList?fromSys='
// 类别管理
export const GetSpecList = baseUrl + 'Menu/GetSpecList?fromSys='

// 根据一级类别查询对应的二级类别
export const getCategoryListByAssortId = baseUrl + "Menu/GetCategoryListByAssortId"

// 获取类别编辑数据
export const getCategoryEdit = baseUrl + 'Menu/NewCategoryEdit?fromSys='
// 提交类别编辑
export const EditCategory = baseUrl + 'Menu/NewAjaxEditCategory'
// 获取添加类别数据
export const getCategoryAdd = baseUrl + 'Menu/NewAddCategory'
// 添加类别
export const AddCategory = baseUrl + 'Menu/NewAjaxAddCategory'

// 一级类别管理页面
export const AssortList = baseUrl + 'Menu/NewAjaxAssortList'
// 添加一级类别详情
export const getAddAssort = baseUrl + 'Menu/NewAddAssort'
// 编辑一级类别详情
export const getEdiAssort = baseUrl + 'Menu/NewAssortEdit'
// 添加一级类别
export const AddAssort = baseUrl + 'Menu/NewAjaxAddAssort'
// 编辑一级类别
export const EditAssort = baseUrl + 'Menu/NewAjaxEditAssort'

// 规格管理页面
export const SpecList = baseUrl + 'Spec/NewAjaxList'
// 编辑规格详情
export const GetSpecEdit = baseUrl + 'Spec/NewSpecEdit'
// 添加规格详情
export const GetSpecAdd = baseUrl + 'Spec/NewAddSpec'
// 编辑规格
export const EditSpec = baseUrl + 'Spec/NewAjaxEditSpec'
// export const SpecEdit = baseUrl + 'Spec/NewAjaxEditSpec'
// 添加规格
export const AddSpec = baseUrl + 'Spec/NewAjaxAddSpec'


// 规格类别页面
export const SpecNameList = baseUrl + 'Spec/NewAjaxSpecNameList'
// 添加规格类别
export const AddSpName = baseUrl + 'Spec/NewAjaxAddSpName'
// 修改规格类别
export const EditSpName = baseUrl + 'Spec/NewAjaxEditSpName'
// 添加规格类别详情
export const GetAddSpName = baseUrl + 'Spec/NewAddSpName'
// 修改规格页面数据
export const GetEditSpec = baseUrl + 'Spec/NewSpNameEdit'

// 普通用户-所有
export const UserList = baseUrl + 'User/NewAjaxList?fromSys='
//小程序登陆
export const XcxList = baseUrl + 'User/GetXcxLogList?fromSys='

// 客户详情
export const UserEdit = baseUrl + 'user/NewEdit?fromSys='
// 派送地址
export const UserAddressList = baseUrl + 'user/NewAjaxGetAddressList?fromSys='

// 获取添加用户地址页面数据
// export const GetAddUserAddress = baseUrl + 'User/AddUserAddress?fromSys='
// 添加用户地址
export const AddUserAddress = baseUrl + 'user/AjaxAddUserAddress'
// 修改用户信息
export const NewUpdateUser = baseUrl + 'User/NewUpdateUser'
// 获取编辑用户地址页面数据
export const getUpdateUserAddress = baseUrl + 'User/NewUpdateUserAddress'
// 更新用户地址
export const UpdateUserAddress = baseUrl + 'user/AjaxUpdateUserAddress'

// 后台导航管理
export const SysConfigList = baseUrl + 'SysConfig/NewAjaxList?fromSys='

// 获取后台导航管理添加子级，新增页面数据
export const getNaviDetails = baseUrl + 'SysConfig/NewEdit'
// 新增或者修改后台管理导航的数据
export const editConfigList = baseUrl + 'SysConfig/NewAjaxEdit'

// 角色管理
export const RolesList = baseUrl + 'Manager/NewAjaxRoles?fromSys='
// 获取角色详情
export const getNewEdit = baseUrl + 'manager/Newedit'
// 提交角色新增
export const addRole = baseUrl + 'manager/NewAjaxAdd'
// 提交角色修改
export const editRole = baseUrl + 'manager/NewAjaxEdit'
// 管理员管理
export const AdminList = baseUrl + 'Manager/NewAjaxManager?fromSys='
// 获取编辑管理员页数据
export const getManagerDetails = baseUrl + 'manager/NeweditManager'
// 管理员详情修改
export const adminEdit = baseUrl + 'Manager/NewAjaxEditManager'
// 管理员新增
export const addAdmin = baseUrl + 'Manager/NewAjaxAddManager'
// 删除管理员
export const DeleteManager = baseUrl + 'manager/AjaxDeleteManager'
// 日志管理
export const LogList = baseUrl + 'Manager/NewAjaxLog?fromSys='

// 打印机管理
export const getPrinterList = baseUrl + 'Printer/NewGetPrinter'
// 新增打印机详情
export const getPrinterNew = baseUrl + 'Printer/NewAdd'
// 添加新打印机
export const addPrinter = baseUrl + 'Printer/NewAddPrinter'
// 修改打印机详情
export const getPrinterEdit = baseUrl + 'Printer/NewEdit'
// 修改打印机状态
export const editPrinter = baseUrl + 'Printer/NewEditPrinter'

// 设备panel管理
export const GetPanel = baseUrl + 'Operation/GetPanel'
// 设备panel管理添加设备
export const saveNewPanel = baseUrl + 'Operation/saveNewPanel'
// 设备panel管理确认添加设备
export const AddPanel = baseUrl + 'Operation/AddPanel'
// 设备panel管理修改详情
export const GetPanelEditInfo = baseUrl + 'Operation/GetPanelEditInfo'
// 设备panel管理修改操作
export const GetPanelEdit = baseUrl + 'Operation/GetPanelEdit'
// 设备panel对应的注册码列表
export const getregCodeList = baseUrl + 'Operation/GetReCodeList'
// lzh 2019-7-11 收银机网络状态管理
// export const GetPosNetwork = baseUrl + 'Operation/GetPosNetwork'
// 设备panel对应生成注册码
export const CreatNewCode = baseUrl + 'Operation/CreateReg'
// 设备panel注册码时间延长
export const ChangeReCode = baseUrl + 'Operation/ChangeReCode'
// 登录状态管理
export const GetLogin = baseUrl + 'Operation/GetLogin'
// 网络状态管理
export const GetNetwork = baseUrl + 'Operation/GetNetwork'
// lzh 2019-7-11 收银机网络状态管理
export const GetPosNetwork = baseUrl + 'Operation/GetPosNetwork'
// lzh 2019-7-12 网络测试
export const setNetTest = baseUrl + 'Operation/setNetTest'
// 设备重启
export const setRestart = baseUrl + 'Operation/Restart'
// 服务员管理
export const getWaiterList = baseUrl + 'User/NewGetWaiter'
// 修改服务员详情
export const getWaiterEdit = baseUrl + 'User/WaiterInfo'
// 修改服务员状态
export const editWaiter = baseUrl + 'User/AddWaiterPermission'
// 同意服务员申请
export const agreeWaiter = baseUrl + 'user/AgreeWaiter'
// 拒绝服务员申请
export const refuseWaiter = baseUrl + 'user/RefuseWaiter'
// 启用服务员
export const activeWaiter = baseUrl + 'user/ActivateWaiter'
// 停用服务员
export const deactiveWaiter = baseUrl + 'user/DeactivateWaiter'
// 保存服务员
export const saveWaiter = baseUrl + 'user/SaveWaiter'

// 店铺管理
export const shopList = baseUrl + 'shop/NewAjaxList'
// 获取店铺编辑页面数据
export const getShopEdit = baseUrl + 'shop/NewEdit'
// 提交修改店铺
export const editAndAddShop = baseUrl + 'shop/NewAjaxEdit'
// 提交新增店铺
export const AddShop = baseUrl + 'shop/NewAjaxAdd'
// 关闭店铺
export const CloseShop = baseUrl + 'shop/NewAjaxClose'

// 动态获取导航栏
export const newIndex = baseUrl + 'Home/NewIndex'

// 时间限制管理
export const getdeallimite = baseUrl + 'shop/GetLimitTimeList'
// 新增时间限制详情
export const getdeallimiteNew = baseUrl + 'shop/NewAddDealtimeInfo'
// 新增时间限制
export const adddeallimiteNew = baseUrl + 'shop/NewAddDealtime'
// 修改时间限制详情
export const getdeallimiteEdit = baseUrl + 'shop/NewEditDealtimeInfo'
// 修改时间限制
export const editdeallimiteEdit = baseUrl + 'shop/NewEditDealtime'
// 创建优惠券的页面
export const AddCoupon = baseUrl + 'coupon/AddCoupon'
// 创建优惠券
export const CreatCoupon = baseUrl + 'coupon/CreatCoupon'
//修改优惠券的页面
export const CouponEdit = baseUrl + 'coupon/CouponEdit'
//修改优惠券
export const AjaxCouponEdit = baseUrl + 'coupon/AjaxCouponEdit'
//获取打印模版
export const getprintmodel = baseUrl + 'weixin/wxadmin_getPrintModel'
//修改打印模版
export const editprintmodel = baseUrl + 'weixin/wxadmin_editPrintModelByPanelId'

// lzh 2019-10-16 设置打印测试
export const setPrintTest = baseUrl + 'Operation/setPrintTest'

// lzh 2019-10-16 获取打印测试
export const getPrintTest = baseUrl + 'Operation/getPrintTest'

export const getTableList=baseUrl+'table/getTableList2'

export const updateTable = baseUrl + 'table/updateTable'

//消费记录
export const userCostLog = baseUrl + 'User/getCostList'
//手动扣款
export const costMoney = baseUrl + 'User/costMoney'
//存款
export const rechargeMoney = baseUrl + 'User/rechargeMoney'
// 充值
export const rechargeMoneyInclubeGift = baseUrl + 'User/rechargeMoneyInclubeGift'
// 获取可用的充值列表
export const getAllRuleList = baseUrl + 'DisCount/getAllRuleList'
// 调整
export const adjustmentUserMoney = baseUrl + 'user/adjustmentUserMoney'

//xgf 2020-7-8
//获取充值优惠列表
export const getRuleList = baseUrl + 'DisCount/getRuleList'
//新增/修改充值
export const saveRule = baseUrl + 'DisCount/saveRule'
//发票列表
export const getAllInvoiceList = baseUrl + 'Order/getAllInvoiceList'
//轮询发票接口
export const nextInvoice = baseUrl + 'Order/getNewInvoice'
//修改发票接口
export const saveInvoice = baseUrl + 'Order/EditInvoice'
//图片上传路径
export const imageUrlPath = "http://pic1.ddk.pub:8011//upload_ajax.ashx?action=Upload&UpFilePath=Filedata&ocr=0&type=0&ipic=ipic"
export const imageUrlRoot = "http://pic1.ddk.pub:8011//"
//优惠券使用记录
export const discountList = baseUrl + "Order/getCouponList"
//预买单
export const printBill = baseUrl + "print/prePrintBill"
//轮询订单/发票接口
export const getPolling = baseUrl+"Order/getPolling"
//用户优惠券/余额提醒
export const couponNotick = baseUrl + "user/couponNotick"
//用户预约
export const getAppointmentlist = baseUrl + "order/getAppointmentlist"
//用户预约详情接口
export const getAppointmentById = baseUrl + "order/getAppointmentById"
//店员审批接口
export const updateAppintment = baseUrl + "order/updateAppintment"
//修改密码
export const updatePassword = baseUrl + "home/updatePassword"

//活动列表
export const getPromotionUsersList = baseUrl + "order/getPromotionUsersList"
//修改活动
export const updatePromotion = baseUrl + 'order/updatePromotion'
//新增活动
export const addPromotion = baseUrl + 'order/addPromotion'
//获取公众号营业数据
export const getWxTurnover = baseUrl + "order/getWxTurnover"
//获取公众号营业数据 测试
export const getWxTurnover1 = baseUrl + "order/getWxTurnover1"
//获取用户详情
export const userDetail = baseUrl + "user/userDetail"
//打印列表
export const getPrintList = baseUrl + "print/printList"
//重新打印
export const printAgent = baseUrl + "print/printAgent"
//用户流水
export const getFundDetailByUid = baseUrl + 'order/getFundDetailByUid'
//历史营业额
export const getAllTurnover = baseUrl + 'order/getAllTurnover'
//历史订单详情
export const getTurnvoerById = baseUrl + 'order/getTurnvoerById'
//商家历史订单
export const getAllOrders1 = baseUrl + 'order/getAllOrders1'
//红包列表
export const getEnvelopeList = baseUrl + 'order/getEnvelopeList'
//红包档次列表
export const getEnvelope = baseUrl + 'order/getEnvelope'
//红包领取记录
export const getEnvelopeLogList = baseUrl + 'order/getEnvelopeLogList'
//获取定向发券的条件
export const getUserCouponList = baseUrl + 'user/getCouponList'
//获取符合条件的用户
export const getCouponUserList = baseUrl + 'user/getCouponUserList'
//定向发券
export const beginSendCoupon = baseUrl + 'user/beginSendCoupon'
//扫码记录
export const getCodeLogList = baseUrl + 'user/getCodeLogList'
//美食达人 商家核销记录报表
export const sjhxListView = baseUrl + 'order/sjhxListView'
//美食达人 商家撤销记录报表
export const cxListView = baseUrl + 'order/cxListView'
//美食达人 商家核销记录报表下载
export const sjhxList = baseUrl + 'order/sjhxList'
//美食达人 商家结算记录报表下载
export const sjjsList = baseUrl + 'order/sjjsList'
//美食达人 商家洗车记录报表下载
export const sjxcList = baseUrl + 'order/sjxcList'
//美食达人 商家门店列表
export const getShopList = baseUrl + 'order/getShopList'
//美食达人 商家门店曝光
export const getADReportInfo = baseUrl + 'order/getADReportInfo'
//美食达人 商家门店曝光 - 2024
export const getADReportInfo2024 = baseUrl + 'order/getADReportInfo2024'
//美食达人 商家门店曝光列表
export const getADShopList = baseUrl + 'order/getADShopList'

//油站 - 洗车券数据
export const xcListView = baseUrl + 'order/xcListView'

// report/xxx : nginx转发:https://report.gogo-oil.com/report/xxx

//Go油惠 - 选择油站
export const jyzShopList = baseUrl + 'user/jyzShopList'
//Go油惠 - 获取油站Id
export const getJyzStationId = baseUrl + 'user/getJyzStationId'
//Go油惠 - 加油站图表 - 左边
export const getJyzShopView = baseUrl + 'order/getJyzShopView'
//Go油惠 - 加油站图表 - 左边 - 直接访问
export const getJyzShopView_true  = baseUrl +'report/getOrderSumInfo'
//Go油惠 - 加油站图表 - 右边
export const getJyzShopViewV1 = baseUrl + 'order/getJyzShopViewV1'
//Go油惠 - 加油站图表 - 右边 - 直接访问
export const getJyzShopViewV1_true = baseUrl +'report/getOrderSumTimesList'
//Go油惠 - 加油站图表 - 流失用户数(今天)
export const getJyzUserDayView = baseUrl + 'order/getJyzUserDayView'
//Go油惠 - 加油站图表 - 流失用户数(今天) - 直接访问
export const getJyzUserDayView_true = baseUrl +'report/getLostUserInfoToDay'
//Go油惠 - 加油站图表 - 流失用户数(昨天)
export const getJyzUserYDayView = baseUrl + 'order/getJyzUserYDayView'
//Go油惠 - 加油站图表 - 流失用户数(今天) - 直接访问
export const getJyzUserYDayView_true = baseUrl +'report/getLostUserInfoYesterDay'
//Go油惠 - 油站优惠变化 - 直接访问
export const  getPetrolStationPriceInfo_true = baseUrl + 'report/getPetrolStationPriceInfo'
//Go油惠 - 流失客户 - 45/90天 直接访问
export const getBackUserInfo_true = baseUrl + 'report/getBackUserInfo'
//Go油惠 - 流失客户 - 45/90天 直接访问 - 多条
export const getBackUserInfo_truev1 = baseUrl + 'report/getBackUserInfoV1'
//Go油惠 - 流失客户 - 单日多次
export const getMultipleDailyUserInfo_true = baseUrl + 'report/getMultipleDailyUserInfo'
//Go油惠 - 流失客户 - 单日多次 - 多条
export const getMultipleDailyUserInfo_truev1 = baseUrl + 'report/getMultipleDailyUserInfoV1'
//Go油惠 - 流失客户 - 下载表格
export const recallUserDol = baseUrl + 'order/recallUserDol'
//Go油惠 - 流失客户 - 下载表格 - 多条
export const recallUserDolV1 = baseUrl + 'order/recallUserDolV1'
//Go油惠 - 订单 - 检测订单状态
export const checkOrder = baseUrl + 'order/checkOrder'
//Go油惠 - 订单 - 订单退款
export const revokeOrder = baseUrl + 'order/revokeOrder'

//测试 - 心跳
export const updatetimeout = baseUrl + 'home/updatetimeout'




//广告日志
export const getAdvertiseLogList = baseUrl + 'user/getAdvertiseLogList'
//广告视图 - 下单记录
export const getActionLogView1 = baseUrl + 'user/getActionLogView1'
//广告视图 - 点击记录
export const getActionLogView2 = baseUrl + 'user/getActionLogView2'
//广告视图 - 用户停留时间分析
export const getActionLogView3 = baseUrl + 'user/getActionLogView3'
//广告视图 - 用户停留时间分析 测试
export const getActionLogView31 = baseUrl + 'user/getActionLogView31'
//广告视图 - 获取广告列表
export const getAdvertList = baseUrl + 'user/getAdvertList'
//广告视图 - 优惠券统计
export const getActionLogView4 = baseUrl + 'user/getActionLogView4'
//广告视图 - 获取商店名称
export const getShopNameList = baseUrl + 'user/getShopNameList'
export const getShopNameList1 = baseUrl + 'user/getShopNameList1'
//广告视图 - 获取用户日志
export const getUserLogList = baseUrl + 'user/getUserLogList'
//打卡记录
export const getPunchClock = baseUrl + 'user/getPunchClock'
//签到记录
export const getSigninLogList = baseUrl + 'user/getSigninLogList'
//获取所有DB
export const getBDNameList = baseUrl + 'user/getBDNameList'
//打卡图片
export const punchRoot =  'http://msdrpunch.ddk.pub';
//美食达人商家买单数据
export const getMDKTurnover = baseUrl + 'order/getMDKTurnover'
//美食达人商家 付款码+公众号付款
export const getShopOrderList = baseUrl + 'order/getShopOrderList'
//美食达人商家 bd列表
export const getBdList = baseUrl + 'order/getBdList'
//纸巾码数据
export const getserLogList = baseUrl + 'order/getserLogList'
//广告分析 - 获取商店
export const getShopClientIdList = baseUrl + 'user/getShopClientIdList'
//广告分析 - 初版
export const getAdvertLogList = baseUrl + 'user/getAdvertLogList'
//广告数据 - 简单总结
export const advertLogGather = baseUrl + 'user/advertLogGather'
//广告数据 - 新版广告fromid列表
export const getNewFromidList = baseUrl + 'user/getNewFromidList'
//广告数据 - 答题广告fromid列表
export const getQuestionAdvList = baseUrl + 'user/questionAdvList'
//广告数据 - 用户答题列表
export const getQuestionLogList = baseUrl + 'user/questionLogList' 
//广告数据 - 广告结算
export const getOrderListPc = baseUrl + 'order/getOrderListPc'
//广告数据 - 广告结算 新
export const getOrderListPcNew = baseUrl + 'order/getOrderListPcNew'
//广告数据 - 广告结算 - 修改套餐结算单价
export const updateMenuMoney = baseUrl + 'order/updateMenuMoney'
//广告数据 - 广告结算 - 结算
export const insertShopSettlement = baseUrl + 'order/insertShopSettlement'

//广告数据 - 获取分享人信息
export const getActUser = baseUrl + "user/getActUser"

//-------------------暂时没用 2020/09/21--------------------------
//获取所有桌
export const getTableList3 = baseUrl + 'table/getTableList3'
//更新/新增桌
export const saveTable = baseUrl + 'table/saveTable'


// WEBPACK FOOTER //
// ./src/api/api.js